<template>
  <div class="ds-progress-bar" :class="[sizeClass, { 'ds-progress-bar--indeterminate': indeterminate }]">
    <div
      class="ds-progress-bar__indicator"
      :class="[
        colorClass,
        {
          'ds-progress-bar__indicator--indeterminate': indeterminate,
          'ds-progress-bar__indicator--smooth': smooth && !indeterminate,
        },
      ]"
      :style="indeterminate ? null : { width: `${progress * 100}%` }"
    />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      validator(value) {
        return ['green'].indexOf(value) !== -1;
      },
      default: 'green',
    },
    size: {
      type: String,
      validator(value) {
        return ['', 'small'].indexOf(value) !== -1;
      },
      default: '',
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    // Opt-in so the existing consumers, which jump between a handful of fixed values, keep
    // rendering exactly as they did; only a bar ticking on a timer needs the glide.
    smooth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorClass() {
      return {
        green: 'ds-progress-bar__indicator--green',
      }[this.color];
    },
    sizeClass() {
      return {
        small: 'ds-progress-bar--small',
      }[this.size];
    },
  },
};
</script>

<style lang="scss">
@use "@sass/design-system/progress-bar";
</style>
